var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-preview form-control closed",attrs:{"disabled":""}},[_vm._m(0),_c('div',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.translationFile.title))]),(_vm.translationFile.size)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.translationFile.size))]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa-solid fa-file-pdf icon"})])
}]

export { render, staticRenderFns }